import { createSlice } from '@reduxjs/toolkit';

import { AppState } from '~/types';

export const appState: AppState = {
  query: 'react',
  loader: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState: appState,
  reducers: {
    setAppOptions: (draft, { payload }) => {
      draft.query = payload.query;
    },
    showLoader: draft => {
      draft.loader = true;
    },
    hideLoader: draft => {
      draft.loader = false;
    },
  },
});

export const { setAppOptions, showLoader, hideLoader } = appSlice.actions;
export default appSlice.reducer;
